module.exports = __webpack_public_path__ + "img/paperboi-untitled.9263790.jpg";